
        var result = require("!!../../../../../node_modules/css-loader/index.js!./cotwo-statistics.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/cotwo/cotwo-statistics/cotwo-statistics.component.css
// module id = 776
// module chunks = 0